/* fc-pp-related.js (2026-10-12 speed pass): the related-products rail and its quick-add buttons.
   Moved out of sections/fc-pp-related.liquid so browsers cache it across product
   pages; the root is #fc-pp-related and per-instance values travel as data
   attributes (or the JSON config script). The bodies are the former inline
   scripts, unchanged apart from those lookups. Re-initialises on
   shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initRelated(root) {

  var track = root.querySelector('[data-fc-rel-track]');
  var prevBtn = root.querySelector('[data-fc-rel-prev]');
  var nextBtn = root.querySelector('[data-fc-rel-next]');
  var fill = root.querySelector('[data-fc-rel-fill]');
  var countEl = root.querySelector('[data-fc-rel-count]');
  if (!track) return;

  function getCardWidth() {
    var first = track.querySelector('.fc-rel-card');
    if (!first) return 0;
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || 0);
    return first.offsetWidth + gap;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function update() {
    var max = track.scrollWidth - track.clientWidth;
    var pct = max > 0 ? track.scrollLeft / max : 0;
    var visibleWidth = track.clientWidth;
    var totalWidth = track.scrollWidth;
    var thumbWidth = totalWidth > 0 ? (visibleWidth / totalWidth) * 100 : 100;
    fill.style.width = thumbWidth + '%';
    fill.style.left = ((100 - thumbWidth) * pct) + '%';

    var cardW = getCardWidth();
    var total = track.children.length;
    var visible = Math.round(visibleWidth / cardW);
    var currentIdx = cardW > 0 ? Math.round(track.scrollLeft / cardW) + 1 : 1;
    var lastIdx = Math.min(currentIdx + visible - 1, total);
    if (countEl) countEl.textContent = pad(currentIdx) + ' / ' + pad(total);

    if (prevBtn) prevBtn.disabled = track.scrollLeft < 4;
    if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 4;
  }

  function scrollBy(dir) {
    var cardW = getCardWidth();
    if (cardW === 0) return;
    track.scrollBy({ left: dir * cardW, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { scrollBy(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { scrollBy(1); });
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  // --- Quick add to cart ---
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var PLUS_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  var SPINNER_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 2a10 10 0 0 1 10 10" opacity="1"/><path d="M12 2a10 10 0 0 0-10 10" opacity="0.3"/></svg>';

  root.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-fc-rel-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    btn.classList.add('is-loading');
    btn.innerHTML = SPINNER_SVG;

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function() {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.innerHTML = CHECK_SVG;
      // Dispatch a cart update event for other parts of the theme (header cart count, drawer, etc.)
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:updated'));
      // Try to open cart drawer if the theme has one
      var cartDrawer = document.querySelector('cart-drawer, cart-notification');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
      // Revert to + after 2s so user can add more
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.innerHTML = PLUS_SVG;
      }, 2000);
    })
    .catch(function() {
      btn.classList.remove('is-loading');
      btn.innerHTML = PLUS_SVG;
      alert('Could not add to cart. Please try again.');
    });
  });
  }
  function init() {
    var root = document.getElementById('fc-pp-related');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initRelated(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-pp-related')) init();
  });
})();
